export default function fbTrack(a, b, c) {
  if (process.env.NODE_ENV === `production` && typeof fbq === `function`) {
    // eslint-disable-next-line
    fbq(a, b, c)
  }
}
